<template>
  <div style="margin-top:30px">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" :disabled="isDetail">
      <el-form-item label="打款金额" prop="amount">
        <el-input v-model="form.amount" type="number" disabled />
      </el-form-item>
      <el-form-item label="平台付款银行">
        <el-input v-model="form.platformBank" disabled />
      </el-form-item>
      <el-form-item label="平台开户企业">
        <el-input v-model="form.platformCompanyName" disabled />
      </el-form-item>
      <el-form-item label="平台公户账号">
        <el-input v-model="form.platformAccount" disabled />
      </el-form-item>
      <el-form-item label="收款方银行">
        <el-input v-model="form.bankCode" disabled />
      </el-form-item>
      <el-form-item label="收款方名称">
        <el-input v-model="form.payeeName" disabled />
      </el-form-item>
      <el-form-item label="收款方账号">
        <el-input v-model="form.payeeAccount" disabled />
      </el-form-item>
      <el-form-item label="付款时间" prop="createdTime">
        <el-date-picker
          v-model="form.createdTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期时间"
        />
      </el-form-item>
      <el-form-item label="流水号" prop="orderNo">
        <el-input v-model="form.orderNo" @change="value=>{form.orderNo = value.replace(/\W/g,'')}" />
      </el-form-item>
      <el-form-item label="支付凭证" required>
        <ImgUpload
          :upload-config="{ lebal: '支付凭证', prefix: 'payReceipt', form: form, suffix: 'Img' }"
        />
      </el-form-item>
      <el-form-item v-if="!isDetail">
        <el-button type="primary" @click="formSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import ImgUpload from "@/components/ImgUpload"
import request from '@/utils/request'
export default {
  components:{
    ImgUpload,
  },
  props:{
  },
  data(){
    return {
      dialogVisible:false,
      loading:false,
      isDetail:false,
      tableData:[],
      emptyForm:{
        totalAmount:0,
        platformBank:'',
        platformCompanyName:'',
        platformAccount:'',
        bankName:'',
        name:'',
        account:'',
        createdTime:'',
        orderNo:'',
        payReceipt:''
      },
      form: {
      },
      rules:{
        orderNo: [
          { required: true, message: "请输入流水号", trigger: "change" }
        ],
        createdTime: [
          { required: true, message: "请选择时间", trigger: "blur" }
        ]
      },
      value:''
    }
  },
  created(){},
  methods:{
    // 获取页面信息
    getInfo(code,flag) {
      
      //查询到数据之前先展示空表单
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
       if(flag){
         this.isDetail = true
        }else {
            this.isDetail = false
        }
        
      request({
        url: `/ntocc-tms-api/remitDefinite/${code}`,
        method: 'get'
      }).then((response) => {
        this.form = response.data
        this.$set(this.form,'createdTime',this.form.callbackTime)
      })
    },
    // 提交 
    formSubmit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const data = this.form
          request({
            url: '/ntocc-tms-api/remitDefinite',
            method: 'put',
            data
          }).then((response) => {
            this.$message({ message: response.msg, type: 'success' })
            this.$emit('fatherEditMethod')
          })
        } else {
          return false
        }
      })
    },
    // 关闭
    close(){
      this.$refs.form.resetFields();
      this.dialogVisible = false
    },
    showTime(val){
      // console.log(val);
    }
  }
};
</script>